export default "__VITE_ASSET__BFUtYgpM__"